/*
 * Berkail — Correctif tap iOS (handler tactile trop large du theme Sleek).
 * v3 : regle generique — couvre d'un coup les champs de saisie, les composants web
 * (<shopify-account>, <shopify-chat>, <header-account>, <lookbook-icon>...) et tout
 * element interactif non-standard, sans avoir a les lister un par un.
 *
 * Origine du bug : theme.js ajoute, sur appareil tactile, un handler global 'touchend'
 * (bloc `if (FoxTheme.config.isTouch)`) qui appelle e.preventDefault() sur CHAQUE tap puis
 * ne re-dispatche un click QUE pour a/button/label/select/summary/[role=button]. Tout le
 * reste (inputs, composants web en shadow DOM, points lookbook...) voit son tap natif annule
 * sur mobile : clavier qui ne s'ouvre pas, boutons / points inclicables. Bug du theme Sleek,
 * pas du code custom (absent des versions Sleek anterieures a nov. 2025).
 *
 * Fix : on ecoute 'touchend' en phase CAPTURE (avant le handler du theme, en bubbling) et on
 * stoppe sa propagation pour tout ce qui n'est PAS un a/button/[role=button] — c.-a-d.
 * exactement ce que le handler du theme casse. Les liens et boutons gardent, eux, le
 * comportement d'origine du theme.
 */
(function () {
  var isTouch =
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0;
  if (!isTouch) return;

  document.addEventListener(
    'touchend',
    function (e) {
      var t = e.target;
      if (t && t.closest && !t.closest('a, button, [role="button"]')) {
        e.stopImmediatePropagation();
      }
    },
    { capture: true }
  );
})();